export enum CpoeManagementLink {
    PatientStation = '/PatientStation'
}
